import { render, staticRenderFns } from "./anulacion.vue?vue&type=template&id=bfad31aa"
import script from "./anulacion.vue?vue&type=script&lang=js"
export * from "./anulacion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports